import React from 'react';
import ReactDOM from 'react-dom';
import VehicleTitle from './VehicleTitle';
import propDefs from '../proptypes';
import { remapPrefs } from '../utils/utility';

const VehicleTitleSidebar = ({ vehicle, prefs }) => {
	const [container] = document.querySelectorAll('.ddc-vehicle-title-sidebar');
	const sidebarPrefs = remapPrefs(prefs, '-sidebar');

	return ReactDOM.createPortal(
		<VehicleTitle vehicle={vehicle} prefs={sidebarPrefs} />,
		container
	);
};

VehicleTitleSidebar.propTypes = {
	vehicle: propDefs.settings.vehicle,
	prefs: propDefs.settings.prefs.isRequired
};

VehicleTitleSidebar.defaultProps = {
	vehicle: propDefs.defaults.vehicle
};

export default VehicleTitleSidebar;
